module.exports = __webpack_public_path__ + "img/collection-weddingRingsMen@2x.e13dff4.webp";